import { createUILibraryComponent } from '../core';

export const Box = createUILibraryComponent({
  displayName: 'Box',
  defaultComponent: 'div',
});
